(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
var StyledTable = styled('table').withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-tul2rq-0"
})(["width:100%;border:1px solid #f6f6f6;border-radius:4px;border-spacing:0;border-collapse:separate;font-family:'Mabry Pro';color:#565656;& th{text-align:left;font-weight:900;color:#293440;background-color:#f6f6f6;}& th,td{padding:10px 12px;border:1px solid #f6f6f6;}td:not(:first-child){border-left:none;}td:not(:last-child){border-right:none;}& thead th:first-child{border-top-left-radius:4px;}& thead th:last-child{border-top-right-radius:4px;}& tr:last-child td:first-child{border-bottom-left-radius:4px;}& tr:last-child td:last-child{border-bottom-right-radius:4px;}"]);

var _default = function _default(props) {
  var children = props.children;
  return React.createElement(StyledTable, props, children);
};

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledTable, "StyledTable", "/home/vsts/work/1/s/src/components/tables/Table.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/tables/Table.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();